import { render, staticRenderFns } from "./CertificatesList.vue?vue&type=template&id=1ccbcc77&scoped=true&"
import script from "./CertificatesList.vue?vue&type=script&lang=js&"
export * from "./CertificatesList.vue?vue&type=script&lang=js&"
import style0 from "./CertificatesList.vue?vue&type=style&index=0&id=1ccbcc77&lang=scss&scoped=true&"
import style1 from "./CertificatesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccbcc77",
  null
  
)

export default component.exports